import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { isDefined } from '../../../../../utils/variables';
import { GeodataSetupContext } from '../../../../state/geodata-setup-state';
import { AddOnData, AddOns } from '../../new-cloud-process-dialog/add-ons';

export const ChooseAddons = () => {
  const context = useContext(GeodataSetupContext);
  const { t } = useTranslation();

  if (!isDefined(context)) {
    return null;
  }

  const handleAddOnsChange = (data: AddOnData) => {
    context.setAddons({
      ...context.addons,
      ...data,
      // Merge nested objects to preserve existing properties
      gcpAdjustment: data.gcpAdjustment
        ? {
            ...context.addons?.gcpAdjustment,
            ...data.gcpAdjustment,
          }
        : context.addons?.gcpAdjustment,
      filteredPointCloud: data.filteredPointCloud
        ? {
            ...context.addons?.filteredPointCloud,
            ...data.filteredPointCloud,
          }
        : context.addons?.filteredPointCloud,
    });
  };

  const addons = context.addons;

  return (
    <Container>
      <h4>{t('geodataSetup.addons', { ns: 'cloudProcessing' })}</h4>
      <AddOns
        filteredPointCloud={addons?.filteredPointCloud?.enabled ?? false}
        filteredPointCloudClasses={addons?.filteredPointCloud?.classes}
        filteredPointCloudFormat={addons?.filteredPointCloud?.format}
        filteredPointCloudSpacing={addons?.filteredPointCloud?.spacing}
        gcpAdjustment={addons?.gcpAdjustment?.enabled ?? false}
        gcpAdjustmentComment={addons?.gcpAdjustment?.comment}
        gcpAdjustmentSelfReview={addons?.gcpAdjustment?.selfReview}
        gcpPoints={context.gcpPoints.length > 0}
        terrainModel={addons?.terrainModel?.enabled ?? false}
        useInteractiveSetup={context.useInteractiveSetup}
        onChange={handleAddOnsChange}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
